import React from 'react'
import { Helmet } from 'react-helmet-async'

const SEO = ({ title, description, keywords, tags }) => {
  // Format tags for meta keywords
  // eslint-disable-next-line no-unused-vars
  const formattedTags = tags ? tags.join(', ') : ''
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || formattedTags} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  )
}

export default SEO 